import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-z-small', 'LetterZSmall', [["path",{"d":"M10 8h4l-4 8h4"}]]);